import {Immutable} from "../interfaces/Immutable";
import {BuildingBasicKpis} from "../interfaces/Kpis/BuildingBasicKpis";

const getTotalVisitsCount = (kpi: Immutable<BuildingBasicKpis>) => {
    return kpi.visits.reduce((count, visit) => count + visit.visits, 0);
}

export const KpiModule = {
    getTotalVisitsCount,
}